export default __webpack_public_path__ + "static/male8-1b616cc10696a6da9bca16edda8a2a7c.png";